import { TFunction } from 'i18next';

interface LineItem {
  category: ExpenseParentCategory;
  amount: number;
  description: string;
}

export type DriveCopyStatus = 'pending' | 'uploaded' | 'failed'

export interface ExpenseDocument {
  reference: {
    date: string;
    type: string;
    number: string;
  };
  line_items: LineItem[];
  document_signed_id?: string;
}

export const getParentCategories = (t: TFunction) => [
  { value: 'vehicle_expenses', label: t('expenses.categories.vehicle_expenses') },
  { value: 'commission_fees', label: t('expenses.categories.commission_fees') },
  { value: 'communication_expenses', label: t('expenses.categories.communication_expenses') },
  { value: 'taxes_and_fees', label: t('expenses.categories.taxes_and_fees') },
  { value: 'equipment_and_supplies', label: t('expenses.categories.equipment_and_supplies') },
  { value: 'inverse_vat', label: t('expenses.categories.inverse_vat') },
  { value: 'other_expenses', label: t('expenses.categories.other_expenses') },
]

export type ExpenseParentCategory =
  | "vehicle_expenses"
  | "commission_fees"
  | "communication_expenses"
  | "equipment_and_supplies"
  | "taxes_and_fees"
  | "other_expenses"
  | "inverse_vat";

type VehicleExpenses =
  | "fuel"
  | "maintenance"
  | "car_wash"
  | "parking"
  | "tolls"
  | "depreciation"
  | "rental"
  | "car_payment"
  | "tires"
  | "registration"
  | "inspection"
  | "oil_change"
  | "repairs"
  | "insurance";

type CommissionFees =
  | "platform_commission"
  | "payment_processing"
  | "service_charges"
  | "transaction_fees";

type CommunicationExpenses =
  | "phone"
  | "internet"
  | "data_plan"
  | "software_subscriptions"
  | "navigation";

type EquipmentAndSupplies =
  | "work_clothes"
  | "safety_equipment"
  | "tools"
  | "delivery_equipment"
  | "phone_accessories"
  | "cleaning_supplies";

type TaxesAndFees =
  | "income_tax"
  | "inverse_vat"
  | "social_security"
  | "license_fees"
  | "permits";

type OtherExpenses =
  | "office_supplies"
  | "banking_fees"
  | "professional_services"
  | "training"
  | "miscellaneous";

export type ExpenseCategory =
  | ExpenseParentCategory
  | VehicleExpenses
  | CommissionFees
  | CommunicationExpenses
  | EquipmentAndSupplies
  | TaxesAndFees
  | OtherExpenses;

export type ExpensesErrors = {
  reference?: string[]
  date?: string[]
}
